export const state = () => ({
  percent: '',
  totalSteps: 100,
  contactsRaw: {
    tel: {
      cc1: '0 551 008899',
      cc2: '0 701 008899',
      cc3: '0 222 008899',
    },
    email: {
      cc: 'info@zamat.kg',
    },
  },
});

export const getters = {
  contacts(state) {
    const results = {};

    results.email = Object.entries(state.contactsRaw.email).reduce((acc, [name, value]) => {
      acc[name] = {
        link: `mailto:${value}`,
        displayed: value,
      };
      return acc;
    }, {});

    results.tel = Object.entries(state.contactsRaw.tel).reduce((acc, [name, value]) => {
      acc[name] = {
        link: `tel:${value.replace(/ -/g, '')}`,
        displayed: value,
      };
      return acc;
    }, {});

    return results;
  },

  user(...[, , { auth }]) {
    return auth.user;
  },

  additionalAllowed(...[, { user }]) {
    return Boolean(user.additionalAllowed) && Boolean(user.hasActiveLoan);
  },
};

export const mutations = {
  setPercent(state, percent) {
    state.percent = percent;
  },
};
